import React from 'react';
import { BrowserRouter as Router, Routes, Route, HashRouter } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import BankingUseCases from './components/BankingUseCases';
import OnPremiseSection from './components/OnPremiseSection';
import Integrations from './components/Integrations';
import DemoSection from './components/DemoSection';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Import global styles (which now includes Tailwind)
import './assets/global.css';

// Feature pages
import DataSourcesPage from './pages/DataSourcesPage';
import AutoDiscoveryPage from './pages/AutoDiscoveryPage';
import ProfilingPage from './pages/ProfilingPage';
import QualityChecksPage from './pages/QualityChecksPage';
import LineagePage from './pages/LineagePage';
import AIPlatformPage from './pages/AIPlatformPage';
import PricingPage from './pages/PricingPage';
import ContactPage from './pages/ContactPage';
import CareerPage from './pages/CareerPage';
import AboutPage from './pages/AboutPage';
import CaseStudiesPage from './pages/CaseStudiesPage';

// Use case pages (now by-use-case solutions)
import DataQualityPage from './pages/solutions/by-use-case/DataQualityPage';
import DashboardIntegrityPage from './pages/solutions/by-use-case/DashboardIntegrityPage';
import DataMeshPage from './pages/solutions/by-use-case/DataMeshPage';

// Persona pages
import DataLeaderPage from './pages/solutions/by-persona/DataLeaderPage';
import DataEngineerPage from './pages/solutions/by-persona/DataEngineerPage';
import DataUserPage from './pages/solutions/by-persona/DataUserPage';

// Home page component
const HomePage = () => (
  <>
    <Hero />
    <Features />
    <BankingUseCases />
    <OnPremiseSection />
    <Integrations />
    <DemoSection />
  </>
);

// Determine if we should use HashRouter based on environment
// Using HashRouter for production to avoid path issues on static hosting
const isProduction = process.env.NODE_ENV === 'production';
const RouterComponent = isProduction ? HashRouter : Router;

function App() {
  return (
    <RouterComponent>
      <div className="App">
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />

          {/* Feature routes */}
          <Route path="/features/data-sources" element={<DataSourcesPage />} />
          <Route path="/features/auto-discovery" element={<AutoDiscoveryPage />} />
          <Route path="/features/profiling" element={<ProfilingPage />} />
          <Route path="/features/quality-checks" element={<QualityChecksPage />} />
          <Route path="/features/lineage" element={<LineagePage />} />
          <Route path="/features/ai-platform" element={<AIPlatformPage />} />

          {/* Solutions by Use Case routes */}
          <Route path="/solutions/by-use-case/data-quality" element={<DataQualityPage />} />
          <Route path="/solutions/by-use-case/dashboard-integrity" element={<DashboardIntegrityPage />} />
          <Route path="/solutions/by-use-case/data-mesh" element={<DataMeshPage />} />

          {/* Solutions by Persona routes */}
          <Route path="/solutions/by-persona/data-leader" element={<DataLeaderPage />} />
          <Route path="/solutions/by-persona/data-engineer" element={<DataEngineerPage />} />
          <Route path="/solutions/by-persona/data-user" element={<DataUserPage />} />

          {/* Legacy routes for backward compatibility */}
          <Route path="/use-cases/data-quality" element={<DataQualityPage />} />
          <Route path="/use-cases/data-observability" element={<DashboardIntegrityPage />} />
          <Route path="/use-cases/dataops-automation" element={<DataMeshPage />} />

          {/* Other routes */}
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/careers" element={<CareerPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
        </Routes>
        <Footer />
      </div>
    </RouterComponent>
  );
}

export default App;
